export const CONVERSATIONS = [
    {
        conversationId: "conv1",
        participants: [
            {
                userId: "1",
                username: "Alice",
                profilePic: "https://picsum.photos/200/200?random=1"
            },
            {
                userId: "2",
                username: "Bob",
                profilePic: "https://picsum.photos/200/200?random=2"
            }
        ],
        hasUnreadMessages: true
    },
    {
        conversationId: "conv2",
        participants: [
            {
                userId: "3",
                username: "Charlie",
                profilePic: "https://picsum.photos/200/200?random=3"
            },
            {
                userId: "4",
                username: "David",
                profilePic: "https://picsum.photos/200/200?random=4"
            }
        ],
        hasUnreadMessages: false
    },
    {
        conversationId: "conv3",
        participants: [
            {
                userId: "5",
                username: "Eva",
                profilePic: "https://picsum.photos/200/200?random=5"
            },
            {
                userId: "6",
                username: "Frank",
                profilePic: "https://picsum.photos/200/200?random=6"
            }
        ],
        hasUnreadMessages: true
    },
    {
        conversationId: "conv4",
        participants: [
            {
                userId: "7",
                username: "Grace",
                profilePic: "https://picsum.photos/200/200?random=7"
            },
            {
                userId: "8",
                username: "Hannah",
                profilePic: "https://picsum.photos/200/200?random=8"
            }
        ],
        hasUnreadMessages: true
    },
    {
        conversationId: "conv5",
        participants: [
            {
                userId: "9",
                username: "Ivy",
                profilePic: "https://picsum.photos/200/200?random=9"
            },
            {
                userId: "10",
                username: "Jack",
                profilePic: "https://picsum.photos/200/200?random=10"
            }
        ],
        hasUnreadMessages: false
    }
];



export const MESSAGES = [
    {
        conversationId: "conv1",
        messages: [
            {
                messageId: "msg1",
                senderId: "1",
                text: "Hey Bob, how's it going?",
                timestamp: "2025-01-24T10:00:00Z",
                image: "https://picsum.photos/500/300?random=1",
                hasUnread: true,
            },
            {
                messageId: "msg2",
                senderId: "2",
                text: "I'm doing great, Alice! What about you?",
                timestamp: "2025-01-24T10:02:00Z",
                image: "https://picsum.photos/500/300?random=2",
                hasUnread: false,
            },
            ...Array.from({ length: 50 }, (_, index) => {
                const messageId = `msg${index + 3}`;
                const senderId = index % 2 === 0 ? "1" : "2"; // Alternates between sender IDs 1 and 2
                const text =
                    senderId === "1"
                        ? `Message from Alice ${index + 3}`
                        : `Reply from Bob ${index + 3}`;
                const timestamp = new Date(
                    new Date("2025-01-24T10:03:00Z").getTime() + index * 60000 // Adds 1 minute per message
                ).toISOString();
                const image = `https://picsum.photos/500/300?random=${index + 3}`;
                const hasUnread = Math.random() > 0.5; // Randomly sets unread status

                return { messageId, senderId, text, timestamp, image, hasUnread };
            }),
        ]
    },
    {
        conversationId: "conv2",
        messages: [
            {
                messageId: "msg3",
                senderId: "3",
                text: "Hey David, did you get the report?",
                timestamp: "2025-01-24T09:00:00Z",
                image: "https://picsum.photos/500/300?random=3",
                hasUnread: false
            },
            {
                messageId: "msg4",
                senderId: "4",
                text: "Yes, it's all set. I'll send it over shortly.",
                timestamp: "2025-01-24T09:05:00Z",
                image: "https://picsum.photos/500/300?random=4",
                hasUnread: false
            }
        ]
    },
    {
        conversationId: "conv3",
        messages: [
            {
                messageId: "msg5",
                senderId: "5",
                text: "Hey Frank, do you have time to meet later today?",
                timestamp: "2025-01-24T11:00:00Z",
                image: "https://picsum.photos/500/300?random=5",
                hasUnread: true
            },
            {
                messageId: "msg6",
                senderId: "6",
                text: "Sure! What time works for you?",
                timestamp: "2025-01-24T11:02:00Z",
                image: "https://picsum.photos/500/300?random=6",
                hasUnread: false
            }
        ]
    },
    {
        conversationId: "conv4",
        messages: [
            {
                messageId: "msg7",
                senderId: "7",
                text: "Hannah, do you want to go for coffee?",
                timestamp: "2025-01-24T12:00:00Z",
                image: "https://picsum.photos/500/300?random=7",
                hasUnread: true
            },
            {
                messageId: "msg8",
                senderId: "8",
                text: "Yes, I'd love that! Where should we go?",
                timestamp: "2025-01-24T12:05:00Z",
                image: "https://picsum.photos/500/300?random=8",
                hasUnread: false
            }
        ]
    },
    {
        conversationId: "conv5",
        messages: [
            {
                messageId: "msg9",
                senderId: "9",
                text: "Hey Jack, are you free to talk?",
                timestamp: "2025-01-24T08:00:00Z",
                image: "https://picsum.photos/500/300?random=9",
                hasUnread: false
            },
            {
                messageId: "msg10",
                senderId: "10",
                text: "Yes, I’m free now. What's up?",
                timestamp: "2025-01-24T08:05:00Z",
                image: "https://picsum.photos/500/300?random=10",
                hasUnread: false
            }
        ]
    }
];


